import React, { Component } from 'react';
import { Row, Col, Input, Button, Form, UncontrolledTooltip } from 'reactstrap';
import { getAPI } from '../Base/API';
import { StyledCard, StatusBadge, PaymentGatewayLogo } from '../Base/Common/CommonUIComponents';
import { getPaymentStatuses, getPaymentGateways } from '../Base/Common/ReferenceDataFunctions';
import { CustomTable } from '../Base/Common/CustomTable';
import moment from "moment";
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import CustomSelect from '../Base/Common/CustomSelect';
import { handleNotification } from '../Base/Common/Notification';

export class SalesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: true,
            endDate: moment(),
            startDate: moment().add(-6, 'months'),
            onlinePaymentsList: [],
            pageIndex: 1,
            pageSize: 10,
            totalItems: 0,
            issuedInvoice: null
        }
    }

    componentDidMount() {
        this.updateStateFilters();
    }
    
    updateStateFilters = () => {
        let params = new URLSearchParams(window.location.search);
        
        if (!params.has('startDate')) params.append('startDate', moment().add(-6, 'months').format('YYYY-MM-DD'));
        if (!params.has('endDate')) params.append('endDate', moment().format('YYYY-MM-DD'));
        if (!params.has('pageIndex')) params.append('pageIndex', 1);
        if (!params.has('pageSize')) params.append('pageSize', 10);

        this.props.history.push({ search: `?${params}` });


        let startDate = params.get('startDate');
        let endDate = params.get('endDate');
        let pageSize = params.get('pageSize');
        let pageIndex = params.get('pageIndex');
        let name = params.get('name');
        let email = params.get('email');
        let paymentStatus = params.get('paymentStatus');
        let paymentGateway = params.get('paymentGateway');
        let issuedInvoice = params.get('issuedInvoice');


        this.setState({
            startDate, endDate,
            pageSize, pageIndex,
            name, email, paymentStatus, paymentGateway, issuedInvoice
        },
        () => this.getOnlinePayments());
    }

    getOnlinePayments = (event, totalItemsToExport, cb, updateUrlParams) => {
        if (event) event.preventDefault();

        this.setState({ block: true });
        
        var params = this.updateAndGetUrlParams(updateUrlParams, totalItemsToExport);

        getAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else {
                    if (totalItemsToExport) {
                        this.setState({ onlinePaymentsList: data.response }, () => { cb(); this.getOnlinePayments() });
                    }
                    else {
                        this.setState({ onlinePaymentsList: data.response, totalItems: data.count, block: false });
                    }
                }
            }
            else this.setState({ error: errorMessage, block: false });
        }, `/api/Voucher/Voucher/v1/onlineSale${params}`);
    }

    updateAndGetUrlParams = (updateUrlParams, totalItemsToExport) => {
        const { channel } = this.props;
        const { startDate, endDate, pageSize, pageIndex, name, email, paymentStatus, paymentGateway, issuedInvoice } = this.state;

        if (updateUrlParams) {
            let url = `?startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&pageSize=${totalItemsToExport ? totalItemsToExport : pageSize}&pageIndex=${totalItemsToExport ? 0 : pageIndex}`;

            if (name) url += `&name=${name}`;
            if (email) url += `&email=${email}`;
            if (paymentStatus) url += `&paymentStatus=${paymentStatus}`;
            if (paymentGateway) url += `&paymentGateway=${paymentGateway}`;
            if (issuedInvoice !== null) url += `&issuedInvoice=${issuedInvoice}`;
            
            this.props.history.push({ search: url });
        }

        var params = `?channel=${channel}&starDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&pageSize=${totalItemsToExport ? totalItemsToExport : pageSize}&pageIndex=${totalItemsToExport ? 0 : pageIndex - 1}`;

        if (name) params += `&name=${name}`;
        if (email) params += `&email=${email}`;
        if (paymentStatus) params += `&paymentStatus=${paymentStatus}`;
        if (paymentGateway) params += `&paymentGateway=${paymentGateway}`;
        if (issuedInvoice !== null) params += `&issuedInvoice=${issuedInvoice}`;

        return params;
    }

    handleCustomExportClick = (cb) => {
        this.setState({ block: true }, _ => this.getOnlinePayments(null, 1000, cb));
    }

    setComboStatus = (name, combo) => {
        this.setState({ [name]: combo ? combo.value : null });
    }

    handleTableChange = (_, { page, sizePerPage }) => {
        this.setState({
            pageIndex: page,
            pageSize: sizePerPage,
        }, () => { this.getOnlinePayments(null, null, null,  true) });
    }

    doSearch = (e) => {
        if(e) e.preventDefault();

        this.setState({ pageIndex: 1 }, () => this.getOnlinePayments(null, null, null,  true))
    }

    render() {
        const { icon, title, channel } = this.props;

        // Front-office sales (channel 2) are paid outside the payment gateways
        const showGateway = channel !== 2;

        const columns = [
            {
                dataField: 'paymentStatus',
                text: this.props.intl.formatMessage({ id: "OnlineSales.PaymentStatus" }),
                sort: true,
                formatter: (cell, row) => (
                    <>
                        <StatusBadge kind="payment" status={cell} />
                        {row.gatewayErrorCode ?
                            <>
                                <i id={`gatewayError${row.id}`} className="fa-solid fa-circle-info text-muted ml-2" />
                                <UncontrolledTooltip placement="right" target={`gatewayError${row.id}`}>
                                    {row.gatewayErrorCode}
                                </UncontrolledTooltip>
                            </>
                        : ''}
                    </>
                )
            },
            ...(showGateway ? [{
                dataField: 'paymentGateway',
                text: this.props.intl.formatMessage({ id: "OnlineSales.Gateway" }),
                sort: true,
                formatter: (cell) => <PaymentGatewayLogo gateway={cell} />
            }] : []),
            {
                dataField: 'name',
                text: this.props.intl.formatMessage({ id: "OnlineSales.Name" }),
                sort: true
            },
            {
                dataField: 'email',
                text: this.props.intl.formatMessage({ id: "OnlineSales.Email" }),
                sort: true
            },
            {
                dataField: 'createdAt',
                text: this.props.intl.formatMessage({ id: "OnlineSales.CreationDate" }),
                sort: true
            },
            {
                dataField: 'Amount',
                text: this.props.intl.formatMessage({ id: "OnlineSales.PayedAmount" }),
                sort: true,
                formatter: (cell, row) => <div >{row.items && row.items.reduce((acc, val) => acc + (val.quantity * val.payedAmount), 0)} </div>,
                csvFormatter: (cell, row) => row.items ? row.items.reduce((acc, val) => acc + (val.quantity * val.payedAmount), 0) : '' 
            },
            {
                dataField: 'Amount',
                text: this.props.intl.formatMessage({ id: "OnlineSales.Quantity" }),
                sort: true,
                formatter: (cell, row) => <div >{row.items && row.items.reduce((a, b) => a + b.quantity, 0)} </div>,
                csvFormatter: (cell, row) => row.items ? row.items.reduce((a, b) => a + b.quantity, 0) : '' 
            },
            {
                dataField: 'channelConfigName',
                text: this.props.intl.formatMessage({ id: "OnlineSales.Channel" }),
                sort: true
            }
        ];

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,

            onSelect: (row, isSelect, rowIndex, e) => {
                this.props.history.push('/OnlineSalesDetail/' + row.id)
            }
        };

        const paymentStatusOptions = getPaymentStatuses();
        const paymentGatewayOptions = getPaymentGateways();

        const issuedInvoiceOptions = [
            {
                value: true,
                label: <FormattedMessage id="OnlineSales.Yes" />
            },
            {
                value: false,
                label: <FormattedMessage id="OnlineSales.No" />
            }
        ];
        

        return (
            <StyledCard icon={icon} title={title} help={this.props.help} id={this.props.id} error={this.state.error} block={this.state.block}>
                <Form onSubmit={this.doSearch}>
                    <Row>
                        <Col className="col-2 px-1">
                            <DateRangePicker
                                startDate={this.state.startDate ? moment(this.state.startDate) : null}
                                startDateId="sellStartid"
                                isOutsideRange={day => day > moment()}
                                endDate={this.state.endDate ? moment(this.state.endDate) : null}
                                endDateId="sellEndid"
                                onDatesChange={({ startDate, endDate }) => this.setState({ startDate: startDate, endDate: endDate })}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                small={true}
                                required
                                numberOfMonths={2}
                                showDefaultInputIcon={true}
                            />
                        </Col>
                        <Col>
                            <FormattedMessage id="OnlineSales.Name">
                                {
                                    placeholder => <Input placeholder={placeholder} value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} ></Input>
                                }
                            </FormattedMessage>
                        </Col>
                        <Col>
                            <FormattedMessage id="OnlineSales.Email">
                                {
                                    placeholder => <Input placeholder={placeholder} value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} ></Input>
                                }
                            </FormattedMessage>
                        </Col>
                        <Col>
                            <CustomSelect
                                options={paymentStatusOptions}
                                placeholder={<FormattedMessage id="OnlineSales.PaymentStatus" />}
                                value={paymentStatusOptions.find(opt => opt.value === this.state.paymentStatus)}
                                onChange={this.setComboStatus.bind(this, 'paymentStatus')}
                                isClearable
                                isSearchable
                            />
                        </Col>
                        {showGateway ?
                            <Col>
                                <CustomSelect
                                    options={paymentGatewayOptions}
                                    placeholder={<FormattedMessage id="OnlineSales.Gateway" />}
                                    value={paymentGatewayOptions.find(opt => opt.value === this.state.paymentGateway)}
                                    onChange={this.setComboStatus.bind(this, 'paymentGateway')}
                                    isClearable
                                    isSearchable
                                />
                            </Col>
                        : ''}
                        <Col>
                            <CustomSelect
                                options={issuedInvoiceOptions}
                                placeholder={<FormattedMessage id="OnlineSales.IssuedInvoice" />}
                                value={issuedInvoiceOptions.find(opt => opt.value === this.state.issuedInvoice)}
                                onChange={this.setComboStatus.bind(this, 'issuedInvoice')}
                                isClearable
                                isSearchable
                            />
                        </Col>
                        <Col className="col-1 text-right">
                            <Button className="btn btn-sm btn-host" type="submit">
                                <i className="fa-solid fa-magnifying-glass" />
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Row>
                    <Col>
                        <CustomTable
                            keyField='id'
                            data={this.state.onlinePaymentsList ? this.state.onlinePaymentsList : []}
                            columns={columns}
                            shadow={false}
                            exportCSV={true}
                            customExportCsv={true}
                            tooltipMessage={<FormattedMessage id="OperationManagement.ExportCsv" />}
                            handleOnClick={this.handleCustomExportClick.bind(this)}
                            showTotal={true}
                            remote={true}
                            selectRow={selectRow}
                            page={parseInt(this.state.pageIndex || 1)}
                            sizePerPage={this.state.pageSize}
                            totalSize={this.state.totalItems}
                            onTableChange={this.handleTableChange}
                        />
                    </Col>
                </Row>
            </StyledCard>
        );
    }
}
export default injectIntl(SalesTable);